module.exports = __webpack_public_path__ + "img/5.7bb3c2e2.jpg";